import useCrmObjectName from 'marketing-platform-lib/hooks/useCrmObjectName';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ObjectTypeName({
  form,
  objectTypeId,
  textTransform = 'none'
}) {
  const {
    objectTypeNamePlural,
    objectTypeNameSingular
  } = useCrmObjectName(objectTypeId, {
    textTransform
  });
  if (form === 'plural') {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: objectTypeNamePlural
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: objectTypeNameSingular
  });
}